import { FLOATING_EXPANDABLE_BUBBLE_MARGIN, FLOATING_EXPANDABLE_BUBBLE_NAVBAR_WIDTH } from "../constants";
import type { BubbleAxisAnchor, BubblePosition } from "../types";
import { clampBoxToMainArea } from "./clamp_to_main_area";

type Point = { left: number; top: number };
type Size = { width: number; height: number };
type Viewport = { width: number; height: number };

const resolveAxis = (
  start: number,
  minStart: number,
  maxStart: number,
  edgeOffset: number
): BubbleAxisAnchor => {
  if (start >= maxStart) {
    return { type: "end", offset: edgeOffset };
  }
  if (start <= minStart) {
    return { type: "start", offset: minStart };
  }
  return { type: "start", offset: start };
};

export const getOpenBoxDropPosition = (
  topLeft: Point,
  viewport: Viewport,
  boxSize: Size,
  margin: number = FLOATING_EXPANDABLE_BUBBLE_MARGIN,
  navbarWidth: number = FLOATING_EXPANDABLE_BUBBLE_NAVBAR_WIDTH
): BubblePosition => {
  const clamped = clampBoxToMainArea(topLeft, viewport, boxSize, margin, navbarWidth);

  const minLeft = margin + navbarWidth;
  const maxLeft = Math.max(minLeft, viewport.width - boxSize.width - margin);
  const minTop = margin;
  const maxTop = Math.max(minTop, viewport.height - boxSize.height - margin);

  return {
    horizontal: resolveAxis(clamped.left, minLeft, maxLeft, margin),
    vertical: resolveAxis(clamped.top, minTop, maxTop, margin)
  };
};
